import claimCvcContactEmailV1Schema from '../schemas/claim-cvc:Contact.email-v1.schema.json';
import claimCvcDocumentDateOfBirthV1Schema from '../schemas/claim-cvc:Document.dateOfBirth-v1.schema.json';
import claimCvcDocumentDateOfExpiryV1Schema from '../schemas/claim-cvc:Document.dateOfExpiry-v1.schema.json';
import claimCvcDocumentEvidencesV1Schema from '../schemas/claim-cvc:Document.evidences-v1.schema.json';
import claimCvcDocumentGenderV1Schema from '../schemas/claim-cvc:Document.gender-v1.schema.json';
import claimCvcDocumentIssueCountryV1Schema from '../schemas/claim-cvc:Document.issueCountry-v1.schema.json';
import claimCvcDocumentNameV1Schema from '../schemas/claim-cvc:Document.name-v1.schema.json';
import claimCvcDocumentNationalityV1Schema from '../schemas/claim-cvc:Document.nationality-v1.schema.json';
import claimCvcDocumentNumberV1Schema from '../schemas/claim-cvc:Document.number-v1.schema.json';
import claimCvcDocumentPlaceOfBirthV1Schema from '../schemas/claim-cvc:Document.placeOfBirth-v1.schema.json';
import claimCvcDocumentTypeV1Schema from '../schemas/claim-cvc:Document.type-v1.schema.json';
import claimCvcEmailDomainV1Schema from '../schemas/claim-cvc:Email.domain-v1.schema.json';
import claimCvcNameFamilyNamesV1Schema from '../schemas/claim-cvc:Name.familyNames-v1.schema.json';
import claimCvcNameGivenNamesV1Schema from '../schemas/claim-cvc:Name.givenNames-v1.schema.json';
import claimCvcNameOtherNamesV1Schema from '../schemas/claim-cvc:Name.otherNames-v1.schema.json';
import claimCvcTypeNameV1Schema from '../schemas/claim-cvc:Type.Name-v1.schema.json';
import claimCvcTypeEmailV1Schema from '../schemas/claim-cvc:Type.email-v1.schema.json';
import claimCvcValidationEvidencesIdDocumentBackV1Schema from '../schemas/claim-cvc:Validation:evidences.idDocumentBack-v1.schema.json';
import claimCvcValidationEvidencesIdDocumentFrontV1Schema from '../schemas/claim-cvc:Validation:evidences.idDocumentFront-v1.schema.json';
import claimCvcValidationEvidencesSelfieV1Schema from '../schemas/claim-cvc:Validation:evidences.selfie-v1.schema.json';
import credentialCvcEmailV3Schema from '../schemas/credential-cvc:Email-v3.schema.json';
import credentialCvcIdDocumentV3Schema from '../schemas/credential-cvc:IdDocument-v3.schema.json';
import cvcDomainNameSchema from '../schemas/cvc:Domain:name.schema.json';
import cvcDomainTldSchema from '../schemas/cvc:Domain:tld.schema.json';
import cvcEmailUsernameSchema from '../schemas/cvc:Email:username.schema.json';
import cvcEvidencesIdDocumentBackSchema from '../schemas/cvc:Evidences:idDocumentBack.schema.json';
import cvcEvidencesIdDocumentFrontSchema from '../schemas/cvc:Evidences:idDocumentFront.schema.json';
import cvcEvidencesSelfieSchema from '../schemas/cvc:Evidences:selfie.schema.json';
import cvcHashAlgorithmSchema from '../schemas/cvc:Hash:algorithm.schema.json';
import cvcHashDataSchema from '../schemas/cvc:Hash:data.schema.json';
import cvcMetaExpirationDateSchema from '../schemas/cvc:Meta:expirationDate.schema.json';
import cvcMetaIssuanceDateSchema from '../schemas/cvc:Meta:issuanceDate.schema.json';
import cvcMetaIssuerSchema from '../schemas/cvc:Meta:issuer.schema.json';
import cvcRandomNodeSchema from '../schemas/cvc:Random:node.schema.json';
import cvcTypeCountrySchema from '../schemas/cvc:Type:country.schema.json';
import cvcTypeDateSchema from '../schemas/cvc:Type:date.schema.json';
import cvcTypeDaySchema from '../schemas/cvc:Type:day.schema.json';
import cvcTypeDocumentTypeSchema from '../schemas/cvc:Type:documentType.schema.json';
import cvcTypeDomainSchema from '../schemas/cvc:Type:domain.schema.json';
import cvcTypeEvidenceSchema from '../schemas/cvc:Type:evidence.schema.json';
import cvcTypeMonthSchema from '../schemas/cvc:Type:month.schema.json';
import cvcTypeYearSchema from '../schemas/cvc:Type:year.schema.json';

const schemaMapping = {
  'claim-cvc:Contact.email-v1': claimCvcContactEmailV1Schema,
  'claim-cvc:Document.dateOfBirth-v1': claimCvcDocumentDateOfBirthV1Schema,
  'claim-cvc:Document.dateOfExpiry-v1': claimCvcDocumentDateOfExpiryV1Schema,
  'claim-cvc:Document.evidences-v1': claimCvcDocumentEvidencesV1Schema,
  'claim-cvc:Document.gender-v1': claimCvcDocumentGenderV1Schema,
  'claim-cvc:Document.issueCountry-v1': claimCvcDocumentIssueCountryV1Schema,
  'claim-cvc:Document.name-v1': claimCvcDocumentNameV1Schema,
  'claim-cvc:Document.nationality-v1': claimCvcDocumentNationalityV1Schema,
  'claim-cvc:Document.number-v1': claimCvcDocumentNumberV1Schema,
  'claim-cvc:Document.placeOfBirth-v1': claimCvcDocumentPlaceOfBirthV1Schema,
  'claim-cvc:Document.type-v1': claimCvcDocumentTypeV1Schema,
  'claim-cvc:Email.domain-v1': claimCvcEmailDomainV1Schema,
  'claim-cvc:Name.familyNames-v1': claimCvcNameFamilyNamesV1Schema,
  'claim-cvc:Name.givenNames-v1': claimCvcNameGivenNamesV1Schema,
  'claim-cvc:Name.otherNames-v1': claimCvcNameOtherNamesV1Schema,
  'claim-cvc:Type.Name-v1': claimCvcTypeNameV1Schema,
  'claim-cvc:Type.email-v1': claimCvcTypeEmailV1Schema,
  'claim-cvc:Validation:evidences.idDocumentBack-v1': claimCvcValidationEvidencesIdDocumentBackV1Schema,
  'claim-cvc:Validation:evidences.idDocumentFront-v1': claimCvcValidationEvidencesIdDocumentFrontV1Schema,
  'claim-cvc:Validation:evidences.selfie-v1': claimCvcValidationEvidencesSelfieV1Schema,
  'credential-cvc:Email-v3': credentialCvcEmailV3Schema,
  'credential-cvc:IdDocument-v3': credentialCvcIdDocumentV3Schema,
  'cvc:Domain:name': cvcDomainNameSchema,
  'cvc:Domain:tld': cvcDomainTldSchema,
  'cvc:Email:username': cvcEmailUsernameSchema,
  'cvc:Evidences:idDocumentBack': cvcEvidencesIdDocumentBackSchema,
  'cvc:Evidences:idDocumentFront': cvcEvidencesIdDocumentFrontSchema,
  'cvc:Evidences:selfie': cvcEvidencesSelfieSchema,
  'cvc:Hash:algorithm': cvcHashAlgorithmSchema,
  'cvc:Hash:data': cvcHashDataSchema,
  'cvc:Meta:expirationDate': cvcMetaExpirationDateSchema,
  'cvc:Meta:issuanceDate': cvcMetaIssuanceDateSchema,
  'cvc:Meta:issuer': cvcMetaIssuerSchema,
  'cvc:Random:node': cvcRandomNodeSchema,
  'cvc:Type:country': cvcTypeCountrySchema,
  'cvc:Type:date': cvcTypeDateSchema,
  'cvc:Type:day': cvcTypeDaySchema,
  'cvc:Type:documentType': cvcTypeDocumentTypeSchema,
  'cvc:Type:domain': cvcTypeDomainSchema,
  'cvc:Type:evidence': cvcTypeEvidenceSchema,
  'cvc:Type:month': cvcTypeMonthSchema,
  'cvc:Type:year': cvcTypeYearSchema,
};

export default schemaMapping;
